import styled from 'styled-components';
import { colors, mediaMax } from '../../../ui/common';

export const Wrap = styled.div``;

export const Title = styled.div`
  font-weight: 600;
  font-size: 38px;
  line-height: 150%;
  color: ${colors.color05};
  text-align: center;
  padding: 120px 0px 70px;
  ${mediaMax.phone`
    font-size: 32px;
  `}
`;

export const List = styled.div`
  max-width: 1140px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 50px;
  ${mediaMax.medium`
    max-width: 930px;
    flex-wrap: nowrap;
    overflow-x: scroll;
  `}
`;
